export const documentAbi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "folderNumber",
        type: "uint256",
      },
      {
        internalType: "string[]",
        name: "_newFileNames",
        type: "string[]",
      },
      {
        internalType: "bytes32[]",
        name: "_hashes",
        type: "bytes32[]",
      },
    ],
    name: "addHash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "folderNumber",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "enum hashStorage.Status",
        name: "status",
        type: "uint8",
      },
    ],
    name: "changeStatus",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "folderNumber",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "_newName",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "_newFileName",
        type: "string",
      },
      {
        internalType: "bytes32",
        name: "_newHash",
        type: "bytes32",
      },
    ],
    name: "update",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "folderNumber",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "fileName",
        type: "string",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "fileHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "enum hashStorage.Status",
        name: "stt",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "address",
        name: "updaterAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "updateDate",
        type: "uint256",
      },
    ],
    name: "updateFileStatus",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "folderNumber",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "folderName",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "fileName",
        type: "string",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "fileHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "updaterAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "updateDate",
        type: "uint256",
      },
    ],
    name: "updateHash",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "folderName",
        type: "string",
      },
      {
        internalType: "string[]",
        name: "_fileNames",
        type: "string[]",
      },
      {
        internalType: "bytes32[]",
        name: "_hashes",
        type: "bytes32[]",
      },
    ],
    name: "write",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "folderNumber",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "folderName",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "fileNames",
        type: "string[]",
      },
      {
        indexed: false,
        internalType: "bytes32[]",
        name: "fileHashes",
        type: "bytes32[]",
      },
      {
        indexed: false,
        internalType: "address",
        name: "hashOwner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "startDate",
        type: "uint256",
      },
    ],
    name: "writeHash",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "_hashes",
        type: "bytes32[]",
      },
    ],
    name: "compareHash",
    outputs: [
      {
        internalType: "bool[]",
        name: "",
        type: "bool[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "folderCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_fileName",
        type: "string",
      },
    ],
    name: "getfolderNumberByFileName",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "hash",
        type: "bytes32",
      },
    ],
    name: "getfolderNumberByHash",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "folderName",
        type: "string",
      },
    ],
    name: "getfolderNumberByName",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getStartedBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTotalSlot",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "folderNumber",
        type: "uint256",
      },
    ],
    name: "read",
    outputs: [
      {
        internalType: "string",
        name: "folderName",
        type: "string",
      },
      {
        internalType: "string[]",
        name: "fileName",
        type: "string[]",
      },
      {
        internalType: "bytes32[]",
        name: "fileHash",
        type: "bytes32[]",
      },
      {
        internalType: "enum hashStorage.Status[]",
        name: "fileStatus",
        type: "uint8[]",
      },
      {
        internalType: "address",
        name: "hashOwner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "startDate",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "updateDate",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];
